export const PAID_LOCKED_NOTICE = "Paid invoice: only accounts can edit";
export const NO_EDIT_NOTICE = "You do not have permission to edit this invoice.";

export const hasVerifiedPayment = (invoice) =>
  (invoice?.payments || []).some((payment) => payment.status === "VERIFIED");
